import { render } from "./DisclaimerPolicy.vue?vue&type=template&id=b4124b22"
import script from "./DisclaimerPolicy.vue?vue&type=script&lang=js"
export * from "./DisclaimerPolicy.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/pavithram.org/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__